import {
  Injectable
} from '@angular/core';

import { RendererRegistryService }
from './registry/renderer-registry.service';

import { TextRendererComponent } from '../../partials/components/renderers/text-renderer.component';
import { SelectRendererComponent } from '../../partials/components/renderers/select-renderer.component';
import { AutocompleteRendererComponent } from '../../partials/components/renderers/autocomplete-renderer.component';
import { DateRendererComponent } from '../../partials/components/renderers/date-renderer.component';
import { TextareaRendererComponent } from '../../partials/components/renderers/textarea-renderer.component';
import { CheckboxRendererComponent } from '../../partials/components/renderers/checkbox-renderer.component';
import { MoneyRendererComponent } from '../../partials/components/renderers/money-renderer.component';

@Injectable({
  providedIn: 'root'
})
export class RuntimeRendererLoaderService {

  constructor(
    private registry: RendererRegistryService
  ) {

    this.registry.register(
      'text',
      TextRendererComponent
    );

    this.registry.register(
      'select',
      SelectRendererComponent
    );

    this.registry.register(
    'autocomplete',
    AutocompleteRendererComponent
    );

    this.registry.register(
      'datepicker',
      DateRendererComponent
    );

    this.registry.register(
      'textarea',
      TextareaRendererComponent
    );

    this.registry.register(
      'checkbox',
      CheckboxRendererComponent
    );

    this.registry.register(
      'money',
      MoneyRendererComponent
    );

  }
}